import { render } from "./Banner.vue?vue&type=template&id=18d21d40"
import script from "./Banner.js?vue&type=script&lang=js"
export * from "./Banner.js?vue&type=script&lang=js"

import "./Banner.scss?vue&type=style&index=0&lang=scss"
import "./Banner.vue?vue&type=style&index=1&id=18d21d40&lang=css"
/* custom blocks */
import block0 from "./Banner.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FBanner%2FBanner.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__